import {merge} from 'rxjs';
import {useEffect, useState} from 'react';

import {ChatInput} from '@stripe-internal/conversations-ui';
import {Conversation} from '@stripe-internal/conversations-client';

import {attachmentsEnabled, inputEnabled} from '../lib/util/conversationUtils';
import {useConversationClientPending} from '../hooks/useConversationClientPending';

type Props = {
  conversation: Conversation;
};

export function AssistantInput({conversation}: Props) {
  const [showInput, setShowInput] = useState(inputEnabled(conversation));
  const [disableAttachments, setDisableAttachments] = useState(
    !attachmentsEnabled(conversation),
  );

  const pending = useConversationClientPending(conversation);

  useEffect(() => {
    const sub = merge(
      conversation.statusObservable(),
      conversation.contextObservable(),
    ).subscribe(() => {
      setShowInput(inputEnabled(conversation));
      setDisableAttachments(!attachmentsEnabled(conversation));
    });

    return () => sub.unsubscribe();
  }, [conversation]);

  return (
    <ChatInput
      conversation={conversation}
      attachmentsDisabled={disableAttachments}
      hidden={!showInput}
      pending={pending}
    />
  );
}
